export const STEP_CONFIG = {
  assetAddress: {
    title: "Add New Wallet Address",
    description:
      "New addresses require Travel Rule details and a 24-hour security period before they are activated for withdrawals. Once verified, this wallet will be saved for all future transfers.",
    stepNumber: 1,
  },
  travelRule: {
    title: "Recipient Details",
    description:
      "To help protect your transfers, we need to know where your funds are headed. This information helps us ensure your transactions meet security standards.",
    stepNumber: 2,
  },
} as const;
